var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctBoolean, FctString, FctValue, isVariable } from '../../../Fct/generics';
// [ ADD: "+",
// SUB: "-",
// MUL: "*",
// DIV: "/",
// POW: "**",
// MOD: "%",
// LSHIFT: "<<",
// RSHIFT: ">>",
// AND: "&",
// OR: "|",
// XOR: "^",
// MAX: "max",
// MIN: "min",
// ADD_DECIMALS: "*(10**X)",
// SUB_DECIMALS: "/(10**X)",
// HASH: "keccak256",]
var operatorOptions = [
    { name: 'ADD', value: '+' },
    { name: 'SUB', value: '-' },
    { name: 'MUL', value: '*' },
    { name: 'DIV', value: '/' },
    { name: 'POW', value: '**' },
    { name: 'MAX', value: 'max' },
    { name: 'MIN', value: 'min' },
    { name: 'MOD', value: '%' },
    { name: 'ADD_DECIMALS', value: '*(10**X)' },
    { name: 'SUB_DECIMALS', value: '/(10**X)' },
    //{ name: 'HASH', value: 'keccak256' },
];
var sameDecimalsOperators = ['+', '-', 'max', 'min'];
var zeroDecimalsOperators = ['*', '/', '**', '%'];
var floatingDecimalsOperators = ['*(10**X)', '/(10**X)'];
export var Compute = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'COMPUTED',
    method: 'compute',
    name: 'compute',
    initParams: {
        methodParams: {
            overflow_protection: true,
        },
    },
    getParams: function () { return ({
        input: {
            methodParams: {
                id: new FctString({ readonly: true }),
                value1: new FctValue({ destination: 'wei_amount' }),
                operator1: new FctString({ options: operatorOptions, mode: 'INPUT' }),
                value2: new FctValue({ destination: 'wei_amount' }),
                operator2: new FctString({ options: operatorOptions, required: false, mode: 'INPUT' }),
                value3: new FctValue({ destination: 'wei_amount', required: false }),
                operator3: new FctString({ options: operatorOptions, required: false, mode: 'INPUT' }),
                value4: new FctValue({ destination: 'wei_amount', required: false }),
                overflow_protection: new FctBoolean({ required: false }),
            },
        },
        output: {
            result: new FctValue({ innerIndex: 0 }),
        },
    }); },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, output = _a.output;
        var getParamsAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error, params, setAndValidateParams, initDecimals, i, labelIndex, valueLabel, operatorLabel;
            return __generator(this, function (_a) {
                error = '';
                params = { methodParams: {} };
                setAndValidateParams = function (fromIndex) {
                    if (!fromIndex)
                        return;
                    var decimals = input.methodParams.value1.decimals || 0;
                    for (var i = 1; i <= 4; i++) {
                        var labelIndex = String(i);
                        var prevValueLabel = "value".concat(String(i - 1));
                        var prevOperatorLabel = "operator".concat(String(i - 1));
                        var valueLabel = "value".concat(labelIndex);
                        var operatorLabel = "operator".concat(labelIndex);
                        if (i <= fromIndex) {
                            input.methodParams[valueLabel].hidden = false;
                            if (operatorLabel !== 'operator4') {
                                input.methodParams[operatorLabel].hidden = false;
                            }
                            if (prevValueLabel === 'value0' || prevOperatorLabel === 'operator0') {
                                params.methodParams[valueLabel] = input.methodParams[valueLabel].value;
                                params.methodParams[operatorLabel] = input.methodParams[operatorLabel].value;
                                continue;
                            }
                            var prevValueParam = input.methodParams[prevValueLabel];
                            var prevOperatorValue = input.methodParams[prevOperatorLabel].value;
                            var newValueParam = input.methodParams[valueLabel];
                            if (prevOperatorValue &&
                                !isVariable(prevOperatorValue) &&
                                sameDecimalsOperators.includes(prevOperatorValue)) {
                                // if (newValueParam.decimals && newValueParam.decimals !== prevValueParam.decimals) {
                                //   error += `${error ? '\n' : ''}${valueLabel} wrong decimals: ${newValueParam.decimals} should be ${prevValueParam.decimals}`
                                // }
                                var valueDecimals = prevValueParam.decimals || decimals || 0;
                                newValueParam.decimals = valueDecimals;
                                output.result.decimals = valueDecimals;
                                decimals = valueDecimals;
                            }
                            if (prevOperatorValue &&
                                !isVariable(prevOperatorValue) &&
                                zeroDecimalsOperators.includes(prevOperatorValue)) {
                                // if (newValueParam.decimals && newValueParam.decimals !== 0) {
                                //   error += `${error ? '\n' : ''}${valueLabel} wrong decimals: ${newValueParam.decimals} should be 0`
                                // } else {
                                // }
                                newValueParam.decimals = 0;
                                if (prevOperatorValue === '**' && newValueParam.value && !isVariable(newValueParam.value)) {
                                    decimals = decimals * Number(newValueParam.value);
                                    output.result.decimals = decimals;
                                }
                            }
                            if (prevOperatorValue &&
                                !isVariable(prevOperatorValue) &&
                                floatingDecimalsOperators.includes(prevOperatorValue)) {
                                if (prevOperatorValue === '*(10**X)') {
                                    decimals = Number(prevValueParam.decimals || decimals || 0) + Number(newValueParam.value);
                                }
                                else {
                                    decimals = Number(prevValueParam.decimals || decimals || 0) - Number(newValueParam.value);
                                }
                                if (decimals < 0 || decimals > 64) {
                                    error += "".concat(error ? '\n' : '').concat(valueLabel, " wrong decimals amount you have ").concat(decimals, " but result should be more than 0 and lesss than 64");
                                    newValueParam.value = undefined;
                                    decimals = 0;
                                    continue;
                                }
                                // if (newValueParam.decimals && newValueParam.decimals !== 0) {
                                //   error += `${error ? '\n' : ''}${valueLabel} wrong decimals: ${newValueParam.decimals} should be 0`
                                // } else {
                                // }
                                newValueParam.decimals = 0;
                                output.result.decimals = decimals;
                            }
                        }
                        else {
                            if (!input.methodParams[valueLabel].value)
                                input.methodParams[valueLabel].hidden = true;
                            if (operatorLabel !== 'operator4') {
                                if (!input.methodParams[operatorLabel].value)
                                    input.methodParams[operatorLabel].hidden = true;
                            }
                        }
                        params.methodParams[valueLabel] = input.methodParams[valueLabel].value;
                        if (operatorLabel !== 'operator4') {
                            params.methodParams[operatorLabel] = input.methodParams[operatorLabel].value;
                        }
                    }
                };
                initDecimals = input.methodParams.value1.decimals || 0;
                output.result.decimals = initDecimals;
                for (i = 1; i <= 4; i++) {
                    labelIndex = String(i);
                    valueLabel = "value".concat(labelIndex);
                    operatorLabel = labelIndex !== '4' ? "operator".concat(labelIndex) : undefined;
                    if (!input.methodParams[valueLabel].value || (operatorLabel && !input.methodParams[operatorLabel].value)) {
                        setAndValidateParams(i);
                        break;
                    }
                    if (i === 4) {
                        setAndValidateParams(i);
                    }
                }
                return [2 /*return*/, {
                        params: params,
                        error: Boolean(error) ? error : undefined,
                    }];
            });
        }); };
        return {
            get: getParamsAsync,
            depParamKeys: [
                'methodParams.value1',
                'methodParams.operator1',
                'methodParams.value2',
                'methodParams.operator2',
                'methodParams.value3',
                'methodParams.operator3',
                'methodParams.value4',
            ],
        };
    },
    onChange: function (_a) {
        var input = _a.input, output = _a.output;
        var _b = input.methodParams, id = _b.id, value1 = _b.value1, operator1 = _b.operator1, value2 = _b.value2, operator2 = _b.operator2, value3 = _b.value3, operator3 = _b.operator3, value4 = _b.value4, overflow_protection = _b.overflow_protection;
        output.result.set({
            value: {
                id: id.value,
                type: 'computed',
                value1: value1.value || '',
                operator1: (operator1.value || ''),
                value2: value2.value || '',
                operator2: (operator2.value || ''),
                value3: value3.value || '',
                operator3: (operator3.value || ''),
                value4: value4.value || '',
                overflowProtection: overflow_protection.value === 'false' ? false : true,
            },
        });
    },
});
